import { useQuery } from "@tanstack/react-query";
import type { QueryKey, UseQueryResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import type { GamePassConfigResponse } from "../../types/gamePass";
import { getPrivateInstance } from "../_privateInstance";
import { retryOnTransientErrors } from "./queryUtils";

export const GAME_PASS_CONFIG_QUERY_KEY = ["game-pass", "config"] as const;

export const fetchGamePassConfig = async (): Promise<GamePassConfigResponse> => {
  const response = await getPrivateInstance().get<GamePassConfigResponse>(
    API_ROUTES.GET_GAME_PASS_CONFIG,
  );

  if (!response.data.operator_id?.trim()) {
    throw new Error("Game Pass config missing operator_id");
  }

  return response.data;
};

export const getGamePassConfigQueryOptions = (): {
  queryKey: QueryKey;
  queryFn: typeof fetchGamePassConfig;
  staleTime: number;
  retry: typeof retryOnTransientErrors;
} => ({
  queryKey: [...GAME_PASS_CONFIG_QUERY_KEY],
  queryFn: fetchGamePassConfig,
  staleTime: 1000 * 30,
  retry: retryOnTransientErrors,
});

export const useGetGamePassConfig = (): UseQueryResult<
  GamePassConfigResponse,
  Error
> =>
  useQuery<GamePassConfigResponse, Error>({
    ...getGamePassConfigQueryOptions(),
    refetchOnWindowFocus: false,
  });
